import { render, staticRenderFns } from "./property-view-modal.vue?vue&type=template&id=6ab1d9d6&scoped=true&"
import script from "./property-view-modal.vue?vue&type=script&lang=js&"
export * from "./property-view-modal.vue?vue&type=script&lang=js&"
import style0 from "./property-view-modal.vue?vue&type=style&index=0&id=6ab1d9d6&lang=scss&scoped=true&"
import style1 from "./property-view-modal.vue?vue&type=style&index=1&id=6ab1d9d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab1d9d6",
  null
  
)

export default component.exports
import {QDialog,QCard,QIcon,QCardSection,QImg,QBtn,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QIcon,QCardSection,QImg,QBtn,QSpinnerIos})
